/* src/views/jour/proto/FeuillesJour.jsx — les feuilles d'Aujourd'hui,
   transcrites de docs/handoff/aujourdhui-complet.jsx : déclarer un incident,
   l'incident clos, le dépôt, la liste de courses, le produit, la tâche, et le
   « qui contrôle » du détail ménage. (Le détail ménage lui-même = la MÊME
   feuille que l'accueil : proto/FeuillesComplement.FeuilleMenageDetail.)
   LE DESSIN, PAS LA LOGIQUE — styles copiés tels quels, data-testid ajoutés. */

import React from 'react'

/* ═══ DÉCLARER UN INCIDENT ═════════════════════════════════════════ */
export function FeuilleIncidentDeclare({ logements = [], articles = [], logement,
  onLogement, article, onArticle, photos = [], photosMin = 2, onAppareil,
  onGalerie, pret, onEnregistrer, erreur }) {
  return (
    <>
      <p className="inter" style={{ marginTop: '0' }}>Le logement</p>
      <div className="pastilles" style={{ marginTop: '0' }}>
        {logements.map((l) => (
          <button key={l.id} className={`ag${logement === l.id ? ' on' : ''}`}
            data-testid={`incident-log-${l.id}`}
            onClick={() => onLogement(l.id)}>{l.nom}</button>
        ))}
      </div>
      <p className="inter">Ce qui est abîmé</p>
      <div className="pastilles" style={{ marginTop: '0' }}>
        {articles.map((a) => (
          <button key={a} className={`ag${article === a ? ' on' : ''}`}
            data-testid={`incident-article-${a}`}
            onClick={() => onArticle(a)}>{a}</button>
        ))}
      </div>
      <p className="inter">Les photos</p>
      <div className="carte" style={{ margin: '0',
        ...(photos.length < photosMin
          ? { borderColor: 'var(--terra-bd)', background: 'var(--terra-bg)' } : {}) }}>
        <p style={{ fontSize: '12.5px', margin: '0',
          color: photos.length < photosMin ? 'var(--terra-tx)' : 'var(--vert-tx)' }}>
          <b>{photos.length === 0
            ? `Aucune photo — il en faut ${photosMin === 1 ? 'une' : 'deux'}.`
            : photos.length < photosMin
              ? `${photos.length} photo — il en faut ${photosMin}.`
              : `${photos.length} photos.`}</b>
        </p>
        <div className="act">
          <button className="bt bt-s" data-testid="incident-appareil"
            onClick={onAppareil}>Appareil</button>
          <button className="bt bt-s" data-testid="incident-galerie"
            onClick={onGalerie}>Galerie</button>
        </div>
      </div>
      <div className="act">
        {pret
          ? <button className="bt bt-p" data-testid="incident-declarer"
              onClick={onEnregistrer}>Enregistrer</button>
          : <button className="bt bt-p" style={{ opacity: '.45' }}
              data-testid="incident-declarer-off" disabled>Enregistrer</button>}
      </div>
      <p className="note">Deux photos sont exigées, quel que soit l'endroit d'où vous déclarez.</p>
      {erreur}
    </>
  )
}

/* ═══ L'INCIDENT CLOS / RÉCUPÉRÉ ═══════════════════════════════════ */
export function FeuilleIncidentClos({ etatTitre, etatSous, etatPhrase, recupere,
  lignes = [], onFermer, onRevoir, erreur }) {
  return (
    <>
      <div className="carte" style={{ margin: '0',
        background: recupere ? 'var(--ciel-p)' : 'var(--vert-bg)',
        borderColor: recupere ? '#c3d5e4' : 'var(--vert-bd)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <span style={{ width: '30px', height: '30px', borderRadius: '8px',
            background: '#fff', color: recupere ? 'var(--navy)' : 'var(--vert-tx)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '14px', flexShrink: '0' }}>{recupere ? '♻' : '✓'}</span>
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600',
              color: recupere ? 'var(--navy-d)' : 'var(--vert-tx)' }}>{etatTitre}</span>
            <span style={{ display: 'block', fontSize: '10.5px',
              color: 'var(--gris)' }}>{etatSous}</span>
          </span>
        </div>
        {etatPhrase && (
          <p className="note"
            style={{ color: recupere ? 'var(--navy-d)' : 'var(--vert-tx)' }}>{etatPhrase}</p>
        )}
      </div>
      <p className="inter">Ce qui s'est passé</p>
      <div className="carte" style={{ margin: '0' }}>
        {lignes.map((l, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '9px',
            padding: '8px 0', ...(i ? { borderTop: '1px solid var(--bord)' } : {}) }}>
            <span style={{ flex: '1', fontSize: '12px', color: 'var(--gris)' }}>{l.lb}</span>
            <b style={{ fontSize: '12px', color: 'var(--navy-d)' }}>{l.v}</b>
          </div>
        ))}
      </div>
      <div className="act">
        <button className="bt bt-s" data-testid="incident-clos-fermer"
          onClick={onFermer}>Fermer</button>
        {onRevoir && <button className="bt bt-s" data-testid="incident-clos-revoir"
          onClick={onRevoir}>Revoir la décision</button>}
      </div>
      {erreur}
    </>
  )
}

/* ═══ LE DÉPÔT ═════════════════════════════════════════════════════ */
export function FeuilleDepot({ ou, onOu, logement, produits = [], onMoins, onPlus,
  total, pret, onEnregistrer, onAnnuler, enfantsLogement, renvoiCentral, erreur }) {
  return (
    <>
      <p className="inter" style={{ marginTop: '0' }}>Où déposez-vous</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
        <button onClick={() => onOu('central')} data-testid="depot-central"
          style={ou === 'central'
            ? { display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                textAlign: 'left', border: '2px solid var(--navy)', borderRadius: '12px',
                padding: '9px 11px', background: 'var(--ciel-p)', minHeight: '52px' }
            : { display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                textAlign: 'left', border: '1px solid var(--bord)', borderRadius: '12px',
                padding: '10px 12px', background: '#fff', minHeight: '52px' }}>
          <span style={ou === 'central'
            ? { width: '20px', height: '20px', borderRadius: '50%',
                border: '6px solid var(--navy)', flexShrink: '0' }
            : { width: '20px', height: '20px', borderRadius: '50%',
                border: '1.5px solid #c3cdd6', flexShrink: '0' }} />
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12.5px',
              fontWeight: '600' }}>Au stock central</span>
            <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
              marginTop: '1px' }}>ce que vous rapportez des courses</span>
          </span>
        </button>
        <button onClick={() => onOu('logement')} data-testid="depot-logement"
          style={ou === 'logement'
            ? { display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                textAlign: 'left', border: '2px solid var(--navy)', borderRadius: '12px',
                padding: '9px 11px', background: 'var(--ciel-p)', minHeight: '52px' }
            : { display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                textAlign: 'left', border: '1px solid var(--bord)', borderRadius: '12px',
                padding: '10px 12px', background: '#fff', minHeight: '52px' }}>
          <span style={ou === 'logement'
            ? { width: '20px', height: '20px', borderRadius: '50%',
                border: '6px solid var(--navy)', flexShrink: '0' }
            : { width: '20px', height: '20px', borderRadius: '50%',
                border: '1.5px solid #c3cdd6', flexShrink: '0' }} />
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12.5px',
              fontWeight: '600' }}>Dans un logement</span>
            <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
              marginTop: '1px' }}>ce que vous y laissez en passant</span>
          </span>
        </button>
      </div>
      {enfantsLogement}
      {renvoiCentral}
      {produits.length > 0 && <p className="inter">Ce que vous déposez</p>}
      {produits.length > 0 && (
      <div className="carte" style={{ margin: '0' }}>
        {produits.map((p, i) => (
          <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '9px',
            padding: '8px 0', ...(i ? { borderTop: '1px solid var(--bord)' } : {}) }}>
            <span style={{ flex: '1', minWidth: '0' }}>
              <span style={{ display: 'block', fontSize: '12px', fontWeight: '400',
                color: 'var(--navy-d)' }}>{p.nom}</span>
              <span style={{ display: 'block', fontSize: '9.5px',
                color: 'var(--gris-d)' }}>{p.sous}</span>
            </span>
            <button onClick={() => onMoins(p.id)} data-testid={`depot-moins-${p.id}`}
              style={{ width: '32px', height: '32px', borderRadius: '8px',
                border: '1px solid #c3d5e4', background: '#fff', fontSize: '16px',
                color: 'var(--navy)', flexShrink: '0' }}>−</button>
            <span data-testid={`depot-qte-${p.id}`}
              style={{ minWidth: '26px', textAlign: 'center', fontSize: '13px',
                fontWeight: '600',
                color: p.qte > 0 ? 'var(--navy-d)' : 'var(--gris-d)' }}>{p.qte}</span>
            <button onClick={() => onPlus(p.id)} data-testid={`depot-plus-${p.id}`}
              style={{ width: '32px', height: '32px', borderRadius: '8px',
                border: '1px solid #c3d5e4', background: '#fff', fontSize: '16px',
                color: 'var(--navy)', flexShrink: '0' }}>+</button>
          </div>
        ))}
      </div>
      )}
      {produits.length > 0 && <p className="note">{total
        ? `Ajustez les quantités : le total se calcule tout seul — ${total}.`
        : 'Ajustez les quantités : le total se calcule tout seul.'}</p>}
      <div className="act">
        {pret
          ? <button className="bt bt-p" data-testid="depot-enregistrer"
              onClick={onEnregistrer}>Enregistrer le dépôt</button>
          : <span className="bt bt-p" style={{ opacity: '.4', cursor: 'default' }}
              data-testid="depot-enregistrer-off">Enregistrer le dépôt</span>}
        <button className="bt bt-s" onClick={onAnnuler}>Annuler</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ LA LISTE DE COURSES ══════════════════════════════════════════ */
export function FeuilleCourses({ lignes = [], onCopier, erreur }) {
  return (
    <>
      <div className="info">Les produits sous leur seuil, avec ce qu'il faut racheter pour revenir à deux fois le seuil.</div>
      <div className="carte" style={{ margin: '0' }}>
        {lignes.length === 0 && (
          <p className="note" style={{ margin: 0 }}>Rien sous le seuil — la liste est vide.</p>
        )}
        {lignes.map((l, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px',
            padding: '9px 0', ...(i ? { borderTop: '1px solid var(--bord)' } : {}) }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%',
              background: '#b8412b', flexShrink: '0' }} />
            <span style={{ flex: '1', minWidth: '0' }}>
              <span style={{ display: 'block', fontSize: '12px',
                fontWeight: '600' }}>{l.nom}</span>
              <span style={{ display: 'block', fontSize: '9.5px',
                color: 'var(--gris-d)' }}>il en reste {l.reste} · seuil {l.seuil}</span>
            </span>
            <b style={{ fontSize: '13px', color: '#b8412b',
              flexShrink: '0' }}>+ {l.aRacheter}</b>
          </div>
        ))}
      </div>
      <div className="act">
        <button className="bt bt-p" data-testid="courses-copier"
          onClick={onCopier}>Copier la liste</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ LE PRODUIT ═══════════════════════════════════════════════════ */
export function FeuilleProduit({ qty, unite, sousSeuil, phrase, seuil, onSeuilMoins,
  onSeuilPlus, prix, categorie, unitePrelevement, onDeposer, erreur }) {
  return (
    <>
      <div className="carte" style={{ margin: '0',
        ...(sousSeuil
          ? { background: 'var(--terra-bg)', borderColor: 'var(--terra-bd)' }
          : { background: 'var(--vert-bg)', borderColor: 'var(--vert-bd)' }) }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
          <b style={{ fontSize: '30px',
            color: sousSeuil ? 'var(--terra-tx)' : 'var(--vert-tx)',
            lineHeight: '1' }}>{qty}</b>
          <span style={{ fontSize: '12px',
            color: sousSeuil ? 'var(--terra-tx)' : 'var(--vert-tx)' }}>{unite} au central</span>
        </div>
        <p className="note"
          style={{ color: sousSeuil ? 'var(--terra-tx)' : 'var(--vert-tx)' }}>{phrase}</p>
      </div>
      <p className="inter">Son seuil d'alerte</p>
      <div className="carte" style={{ margin: '0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <span style={{ flex: '1', fontSize: '12px', color: 'var(--gris)' }}>En dessous de cette quantité, il remonte dans la liste de courses</span>
          <button onClick={onSeuilMoins} data-testid="produit-seuil-moins"
            style={{ width: '32px', height: '32px', borderRadius: '8px',
              border: '1px solid #c3d5e4', background: '#fff', fontSize: '16px',
              color: 'var(--navy)' }}>−</button>
          <span data-testid="produit-seuil" style={{ minWidth: '26px',
            textAlign: 'center', fontSize: '14px', fontWeight: '600' }}>{seuil}</span>
          <button onClick={onSeuilPlus} data-testid="produit-seuil-plus"
            style={{ width: '32px', height: '32px', borderRadius: '8px',
              border: '1px solid #c3d5e4', background: '#fff', fontSize: '16px',
              color: 'var(--navy)' }}>+</button>
        </div>
      </div>
      <p className="inter">Ce qu'il coûte</p>
      <div className="carte" style={{ margin: '0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px',
          padding: '7px 0' }}>
          <span style={{ fontSize: '12px', color: 'var(--gris)' }}>Prix à l'unité</span>
          <b style={{ fontSize: '12px' }}>{prix}</b>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px',
          padding: '7px 0', borderTop: '1px solid var(--bord)' }}>
          <span style={{ fontSize: '12px', color: 'var(--gris)' }}>Catégorie</span>
          <b style={{ fontSize: '12px' }}>{categorie}</b>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px',
          padding: '7px 0', borderTop: '1px solid var(--bord)' }}>
          <span style={{ fontSize: '12px', color: 'var(--gris)' }}>Unité de prélèvement</span>
          <b style={{ fontSize: '12px' }}>{unitePrelevement}</b>
        </div>
      </div>
      <div className="act">
        <button className="bt bt-p" data-testid="produit-deposer"
          onClick={onDeposer}>Déposer de ce produit</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ UNE TÂCHE (création / édition) ═══════════════════════════════ */
export function FeuilleTacheEdit({ quoiRef, portee, onPortee, porteeChoix = [],
  jourLb, onJour, heureLb, onHeure, precisionRef, creerLb = 'Créer', onCreer,
  onAnnuler, enfantsQuand, erreur }) {
  return (
    <>
      <div className="carte" style={{ margin: '0' }}>
        <span style={{ display: 'block', fontSize: '11.5px', color: 'var(--gris)',
          marginBottom: '6px' }}>Quoi</span>
        <div contentEditable suppressContentEditableWarning ref={quoiRef}
          data-testid="tache-quoi"
          style={{ border: '1px solid #d5e3ee', borderRadius: '10px', padding: '11px',
            fontSize: '12.5px', fontWeight: '600', color: 'var(--navy-d)',
            minHeight: '40px', outline: 'none' }} />
      </div>
      <p className="inter">Sur quoi elle porte</p>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        {porteeChoix.map((c) => (
          <button key={c.id} onClick={() => onPortee(c.id)}
            data-testid={`tache-portee-${c.id}`}
            style={portee === c.id
              ? { minHeight: '36px', padding: '0 13px', borderRadius: '9px',
                  fontSize: '11.5px', background: 'var(--ciel-p)',
                  border: '1px solid var(--navy)', color: 'var(--navy-d)',
                  fontWeight: '600' }
              : { minHeight: '36px', padding: '0 13px', borderRadius: '9px',
                  fontSize: '11.5px', background: '#fff', border: '1px solid var(--bord)',
                  color: 'var(--gris)' }}>{c.lb}</button>
        ))}
      </div>
      <p className="inter">Quand</p>
      <div className="carte" style={{ margin: '0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '9px 0',
          borderBottom: '1px solid var(--bord)' }}>
          <span style={{ flex: '1', fontSize: '12px', color: 'var(--gris)' }}>Le jour</span>
          <button onClick={onJour} data-testid="tache-jour"
            style={{ display: 'inline-flex', alignItems: 'center', minHeight: '36px',
              padding: '0 12px', borderRadius: '9px', background: '#f8fafc',
              border: '1px solid #d5e3ee', fontSize: '12px', fontWeight: '600',
              color: jourLb ? 'var(--navy-d)' : 'var(--gris-d)',
              flexShrink: '0' }}>{jourLb || '—'}</button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px',
          padding: '9px 0', borderTop: '1px solid var(--bord)' }}>
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12px',
              color: 'var(--gris)' }}>Une heure précise</span>
            <span style={{ display: 'block', fontSize: '9.5px', color: 'var(--gris-d)',
              marginTop: '1px' }}>sans heure, elle reste ici seulement</span>
          </span>
          <button onClick={onHeure} data-testid="tache-heure"
            style={{ display: 'inline-flex', alignItems: 'center', minHeight: '36px',
              padding: '0 12px', borderRadius: '9px', background: '#f8fafc',
              border: '1px solid #d5e3ee', fontSize: '12px', fontWeight: '600',
              color: heureLb ? 'var(--navy-d)' : 'var(--gris-d)',
              flexShrink: '0' }}>{heureLb || '—'}</button>
        </div>
        {enfantsQuand}
        <p className="note">Lui donner une heure la pose dans votre calendrier. Elle reste ici quand même : c'est ici qu'on la coche.</p>
      </div>
      <div className="carte" style={{ margin: '9px 0 0' }}>
        <span style={{ display: 'block', fontSize: '11.5px', color: 'var(--gris)',
          marginBottom: '6px' }}>Une précision, si besoin</span>
        <div contentEditable suppressContentEditableWarning ref={precisionRef}
          data-testid="tache-precision"
          style={{ border: '1px solid #d5e3ee', borderRadius: '10px', padding: '11px',
            fontSize: '12px', lineHeight: '1.6', color: 'var(--navy-d)',
            minHeight: '60px', outline: 'none' }} />
      </div>
      <div className="act">
        <button className="bt bt-p" data-testid="tache-creer"
          onClick={onCreer}>{creerLb}</button>
        <button className="bt bt-s" onClick={onAnnuler}>Annuler</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ QUI CONTRÔLE (détail ménage → Contrôler) ═════════════════════ */
export function FeuilleQuiControle({ onRetour, agents = [], choisi, onChoisir,
  exclusion, onMoiMeme, enfantsActe, erreur }) {
  return (
    <>
      <button onClick={onRetour} data-testid="qui-controle-retour"
        style={{ fontSize: '11.5px', color: 'var(--navy)', padding: '0 0 10px',
          background: 'none', border: 'none' }}>‹ Retour</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px',
        margin: '16px 0 9px' }}>
        <span style={{ width: '24px', height: '24px', borderRadius: '7px',
          background: 'var(--ambre)', color: '#fff', display: 'flex',
          alignItems: 'center', justifyContent: 'center', flexShrink: '0' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </span>
        <span style={{ fontSize: '11.5px', fontWeight: '600',
          color: 'var(--ambre-tx)' }}>Qui contrôle</span>
      </div>
      <div className="carte" style={{ margin: '0' }}>
        <div className="pastilles" style={{ marginTop: '0' }}>
          {agents.map((a) => (
            <button key={a.id} className={`ag${choisi === a.id ? ' on' : ''}`}
              data-testid={`qui-controle-${a.id}`}
              onClick={() => onChoisir(a.id)}>
              <span className="av">{a.ini}</span>{a.nom}</button>
          ))}
        </div>
        <p className="note">{exclusion}</p>
        <div className="act">{enfantsActe}</div>
      </div>
      <div className="carte" style={{ margin: '9px 0 0', borderColor: '#c3d5e4',
        background: 'var(--ciel-p)' }}>
        <p className="note" style={{ margin: '0' }}>Vous n'êtes pas dans la liste : vous contrôlez quand vous voulez, sans être désigné.</p>
        <div className="act">
          <button className="bt bt-p" data-testid="qui-controle-moi"
            onClick={onMoiMeme}>Je contrôle maintenant</button>
        </div>
      </div>
      {erreur}
    </>
  )
}
